import httpRequest, { httpAnonymousRequest } from 'httpRequest'
import {
    ClosingProceduresContract,
    CurrencyCashDenominationContract,
    MenuConfigurationContract,
    PinSettingContract,
} from 'models'
import { PosOperationalSettingContract } from 'models'
import { GeneralPOSTerminalContract } from 'models'
import {
    GeneralSettingContract,
    OperationalSettingContract,
    SaleProcessingSettingContract,
} from 'models'
import { GiftCardSettingContract } from 'models/GiftCardSettingContract'
import { CompSettingContract } from 'pages/PosPage/General/hooks/CompSettingContract'

const LOCATION_OPERATIONAL_SETTING_PREFIX = '/location/operational-setting'

const GENERAL_SETTING = `${LOCATION_OPERATIONAL_SETTING_PREFIX}/general`

const SALE_PROCESSING_SETTING = `${LOCATION_OPERATIONAL_SETTING_PREFIX}/sale-processing`

const CLOSING_PROCEDURE_SETTING = `${LOCATION_OPERATIONAL_SETTING_PREFIX}/close-procedures`

const GENERAL_POS_TERMINAL_SETTING = `${LOCATION_OPERATIONAL_SETTING_PREFIX}/general-pos-terminal`

const COMP_SETTING = `${LOCATION_OPERATIONAL_SETTING_PREFIX}/comp-setting`

const PIN_LENGTH_SETTING = `${LOCATION_OPERATIONAL_SETTING_PREFIX}/update-pin-length`

const ENABLE_GIFT_CARD_SALES_SETTING = `${LOCATION_OPERATIONAL_SETTING_PREFIX}/update-gift-card-sales-setting`

const operationalSettingService = {
    getOperationSetting() {
        return httpAnonymousRequest.get<PosOperationalSettingContract>(
            LOCATION_OPERATIONAL_SETTING_PREFIX,
        )
    },
    updateOperationSetting(
        body: OperationalSettingContract,
        forceReload: boolean = false,
    ) {
        return httpRequest.put(
            `${LOCATION_OPERATIONAL_SETTING_PREFIX}?forceReload=${forceReload}`,
            body,
        )
    },
    updateMenuConfiguration(body: MenuConfigurationContract) {
        return httpRequest.put(
            `${LOCATION_OPERATIONAL_SETTING_PREFIX}/menu-configuration`,
            body,
        )
    },
    updateGeneralSetting(
        payload: GeneralSettingContract,
        forceReload: boolean = false,
    ) {
        return httpRequest.put(
            `${GENERAL_SETTING}?forceReload=${forceReload}`,
            payload,
        )
    },
    updateSaleProcessingSetting(payload: SaleProcessingSettingContract) {
        return httpRequest.put(SALE_PROCESSING_SETTING, payload)
    },

    updateClosingProcedureSetting(payload: ClosingProceduresContract) {
        return httpRequest.put(CLOSING_PROCEDURE_SETTING, payload)
    },
    updateGeneralPOSTerminalSetting(payload: GeneralPOSTerminalContract) {
        return httpRequest.put(GENERAL_POS_TERMINAL_SETTING, payload)
    },
    updatePinLengthSetting(payload: PinSettingContract) {
        return httpRequest.put<number>(`${PIN_LENGTH_SETTING}`, payload)
    },
    updateGiftCardSalesSetting(payload: GiftCardSettingContract) {
        return httpRequest.put<number>(
            `${ENABLE_GIFT_CARD_SALES_SETTING}`,
            payload,
        )
    },
    toggleCalculateCompAfterDiscount(payload: CompSettingContract) {
        return httpRequest.put<boolean>(
            `${COMP_SETTING}/toggle-calculator`,
            payload,
        )
    },
    getCurrencyCashDenomination: () => {
        return httpRequest.get<CurrencyCashDenominationContract[]>(
            `${LOCATION_OPERATIONAL_SETTING_PREFIX}/currency-cash-denomination`,
        )
    },
}

export default operationalSettingService
